import { createContext } from "react";

export const AppContext = createContext({
	setShowFull: (val: boolean) => {},
	setPreview: (val: string) => {},
});
